import { render, staticRenderFns } from "./TKPendingRequestDialog.vue?vue&type=template&id=0d96df00&scoped=true"
import script from "./TKPendingRequestDialog.vue?vue&type=script&lang=js"
export * from "./TKPendingRequestDialog.vue?vue&type=script&lang=js"
import style0 from "./TKPendingRequestDialog.vue?vue&type=style&index=0&id=0d96df00&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d96df00",
  null
  
)

export default component.exports